import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { useSelector } from "react-redux";
import { Line } from "react-chartjs-2";
import { useNavigate } from "react-router-dom"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import Followsvg from "../Asset/esocardicon/BacklinkTrends/Follow.svg"
import Nofollowsvg from "../Asset/esocardicon/BacklinkTrends/Nofollow.svg"
import TotalBacklinkssvg from "../Asset/esocardicon/BacklinkTrends/TotalBacklinks.svg"
import DatagridComp from "../DatagridComp";
import Commoncard from "../Commoncard";
import { GetuserDatavalue } from "../../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import { Container, Grid, Box } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";

export default function BacklinksTrend(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [TotalBacklinkCount, SetTotalBacklinkCount] = useState(0)
  const [FollowCount, SetFollowCount] = useState(0)
  const [NofollowCount, SetNofollowCount] = useState(0)
  const navigate = useNavigate()
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const fillColor = "rgb(255,174,31)";
  const [columns, Setcolumns] = useState([]);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const labelColours = ['#cd0f89', '#3009bb', '#2ed7d0', '#cd0f2b', '#00cd98', '#eeec1a', '#2e90d7', '#f5833f', '#bce6f5', '#9ea3a4', '#c42cf1', '#569073', '#00ff28', '#ffa2e3', '#afee1a', '#cd0fb8', '#f5c03f', '#f54b3f', '#ffaee2', '#692cf1'];


  const columnsIni = [

  ];

  const rows = cardData ?? [];
  const ColorObj = [{
    borderColor: "orange",
    backgroundColor: "rgb(255, 235, 219)",
    fill: {
      target: "origin",
      above: "rgba(255, 235, 219, 0.3)"
    }

  }]
  const LoadData = async (tableid = '') => {
    var JobId = '';
    if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value
      }
    }
    setLoading(true);
    setTableLoading(true);
    try {
      const datavalueKpi = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_trend_count/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalueKpi?.data) {
        if (datavalueKpi?.data?.total_backlinks_count) {
          SetTotalBacklinkCount(datavalueKpi.data.total_backlinks_count)
        }
        if (datavalueKpi?.data?.total_do_follow_count) {
          SetFollowCount(datavalueKpi.data.total_do_follow_count)
        }
        if (datavalueKpi?.data?.total_no_follow_count) {
          SetNofollowCount(datavalueKpi.data.total_no_follow_count)
        }
      }
    } catch (err) {
      console.log(err)
    }
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_trend_graph/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      var ResultData = [];
      if (datavalue?.data) {
        if (datavalue?.data?.result) {
          ResultData = datavalue.data.result
        }
      }
      const labelsIn = ResultData.map(entry => entry.Month.toString());
      const arrayOfKeys = ResultData.map(obj => Object.keys(obj));
      var FrameDataSetKey = arrayOfKeys;
      const FrameDataSetValue = [];
      if (FrameDataSetKey) {
        FrameDataSetKey = FrameDataSetKey[0]
        FrameDataSetKey = FrameDataSetKey.filter(item => item !== 'Month');
        FrameDataSetKey.forEach((element, i) => {
          const arrayValues = ResultData.map(obj => obj[element]);
          const Cobj = ColorObj[0];
          const object1 = {
            label: element,
            data: arrayValues,
            borderColor: labelColours[i],
            backgroundColor: i > 20 ? getRandomColor() : labelColours[i],
            fill: false,
          }
          FrameDataSetValue.push(object1)
        });

      }
      SetLabelData(labelsIn)
      props.setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      SetDataSetsValue(FrameDataSetValue)
    } catch (err) {
      SetLabelData([])
      console.log(err)
    }
    try {
      const datavalueTable = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_trend_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      var labelsIn = []
      if (datavalueTable?.data?.table_headers) {
        labelsIn = datavalueTable.data.table_headers
      }
      var ColumnsMerge = [];
      labelsIn.forEach(element => {
        var Height = 200;
        if (element === 'Domains') {
          Height = 300
        }
        ColumnsMerge.push({
          field: element,
          headerName: element,
          minWidth: Height,
          flex: 1,
          disableClickEventBubbling: true,
          headerAlign: "center",
          align: "center",
        })
      });
      ColumnsMerge = columnsIni.concat(ColumnsMerge)
      Setcolumns(ColumnsMerge)
      const dataval = datavalueTable?.data?.table_body;
      if (dataval) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setCardData(newData);
        SetAutoheightval(false)
      }
      else {
        setCardData([]);
        SetAutoheightval(true)
      }
    } catch (err) {
      setCardData([])
      console.log(err)
    }
    setTableLoading(false);
    setLoading(false);
  }
  const [LabelData, SetLabelData] = useState([])
  const [DataSetsValue, SetDataSetsValue] = useState([]
    //   [
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove system Egrovesystem"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Javascript"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Javascript"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove system"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove systemEgrovesystem"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove system Egrove system"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove system"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove system"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Javascript"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Javascript"
    //   },
    //   {
    //     backgroundColor: "#cd0f2b",
    //     borderColor: "#cd0f2b",
    //     data: [0, 0, 40514, 40025, 42518, 0],
    //     fill: false,
    //     label: "Egrove system Egrove system"
    //   },
    // ]
  )
  const chartData = {
    labels: LabelData,
    datasets: DataSetsValue
  };

  const chartOptions = {
    scales: {
      x: {
        type: 'category',
        position: 'bottom',
        ticks: {
          color: '#0b2033'
        },

      },
      y: {

        ticks: {
          color: '#0b2033'
        },

      },

    },
    plugins: {
      legend: {
        display: false

      }
    }
  };

  function getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  const cardDatas = [
    { title: "Total Backlinks", value: TotalBacklinkCount, iconSrc: TotalBacklinkssvg, altText: "Total Backlinks", iconColor: 1, bgColor: 1 },
    { title: "Follow", value: FollowCount, iconSrc: Followsvg, altText: "Follow", iconColor: 2, bgColor: 2 },
    { title: "No follow", value: NofollowCount, iconSrc: Nofollowsvg, altText: "No follow", iconColor: 3, bgColor: 3 }
  ];


  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    LoadData()
  }, []);

  useEffect(() => {
    if (props.FilterButtonTriggered === true) {
      LoadData()
      props.SetFilterButtonTriggered(false)
      props.closeModal()
    }
  }, [props])

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleModelPopUp = () => {
    props.openModal();
  }

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Backlinks Trend</title>
      </Helmet>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="common-card-container" style={{ justifyContent: "center" }}>
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Commoncard item={item} />
                  </Grid>
                ))}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-card-container">
        <Box >
          <Grid container>
            <Grid container spacing={3} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="graph-container">
        <Box className="graph-box">
          <Grid container className="graph-grid">
            <Grid item xs={12} md={12}>
              <div className="site_regress_chart_info">
                <div className="site_Chart_info_inner">
                  <Line data={chartData} options={chartOptions} />
                  <p style={{ color: "#ff601f" }}>Backlinks Trends</p>
                  <div className="rounded-dot-row" style={{ display: "block", textAlign: "center" }}>
                    {DataSetsValue.map((labelcolor, i) => (
                      <>
                        {/* <div>
                            <div className="rounded-dot-col"> */}
                        <span className="graph-labels" >
                          <span class="rounded-dot" style={{ backgroundColor: i > 20 ? getRandomColor() : labelColours[i], marginRight: "5px" }}></span><span class="kw-trend-opt">{labelcolor.label}</span>
                        </span>
                        {/* </div>
                          </div> */}
                        {/* {i % 4 === 0 && i % 1 !== 0 &&
                          <div><br /></div>
                        } */}

                      </>
                    )
                    )}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <DatagridComp
        columns={columns}
        rows={rows}
        autoheightval={autoheightval}
        datagridval={2}
        columnFreezeWidth={[0]}
        tableLoading={tableLoading}
      /> */}

      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <UserActivityTracker pagename="Backlinks - Backlinks Trend" />

    </>
  );
}
